import { Link } from "@mui/material";

export const ProjectLink = ({
  projectId,
  displayName,
}: {
  projectId: string;
  displayName: string;
}) => {
  return <Link href={`/projects/${projectId}`}>{displayName}</Link>;
};
